module.exports = __webpack_public_path__ + "assets/img/gnome.2254c79a.png";